// extracted by mini-css-extract-plugin
export default {"row":"page-heading_row__Hyh4I","title":"page-heading_title__gI7BF","titleSub":"page-heading_titleSub__kyD0z","count":"page-heading_count__SPcvc"};